import _ from 'lodash';

const getScoreIndex = (header) => {
  const scoreIndex = _.findIndex(header, title => title === 'スコア');

  if (scoreIndex === -1) {
    // 念のため、'得点'でも大丈夫にしておく
    return _.findIndex(header, title => title === '得点');
  }

  return scoreIndex;
};

const getValidScores = (papaData) => {
  const [header, ...data] = papaData;

  const scoreIndex = getScoreIndex(header);

  if (scoreIndex === -1) {
    return [];
  }

  const validData = _.filter(data, datum => (datum[scoreIndex] !== '' && datum[scoreIndex] !== ' '));
  const validScores = validData.map(datum => _.toNumber(datum[scoreIndex]));

  return validScores;
};

export default getValidScores;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/utils/getValidScores.js